import { TokenModel } from "@/models/token.model";

export class SessionManager {
    public static saveAuth(model: TokenModel) {
        sessionStorage.clear()
        sessionStorage.setItem('std-auth', JSON.stringify(model))
    }

    private static getAuth(): TokenModel {
        const ss = sessionStorage.getItem('std-auth')
        if (ss == undefined) throw new Error('No login data')
        return JSON.parse(ss)
    }

    public static getAccessToken() {
        return this.getAuth().accessToken
    }

    public static getRefreshToken() {
        return this.getAuth().refreshToken
    }

    public static getStudentId() {
        return this.getAuth().id
    }

    public static hasAuth() {
        if (sessionStorage.getItem('std-auth')) {
            return true
        }
        return false
    }

    public static clearAuth() {
        sessionStorage.clear()
    }
}